import React, { useState } from 'react';
import { Upload, X } from 'lucide-react';
import { uploadProductImage, uploadLogo, uploadCategoryImage } from '../services/api';
import { toast } from 'sonner';

const ImageUpload = ({ value, onChange, onThumbnailChange, type = 'product', label = 'Imagen', categoryId = null }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(value || null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Por favor selecciona una imagen válida');
      return;
    }

    // Validate file size
    const maxSize = type === 'logo' ? 5 : type === 'category' ? 5 : 10;
    if (file.size > maxSize * 1024 * 1024) {
      toast.error(`La imagen es muy grande (máx ${maxSize}MB)`);
      return;
    }

    setUploading(true);
    try {
      let response;
      if (type === 'category' && categoryId) {
        response = await uploadCategoryImage(categoryId, file);
      } else if (type === 'logo') {
        response = await uploadLogo(file);
      } else {
        response = await uploadProductImage(file);
      }
      const imageUrl = type === 'logo' ? response.data.logo_url : response.data.image_url;
      const thumbnailUrl = response.data.thumbnail_url;

      setPreview(imageUrl);
      onChange(imageUrl);
      if (onThumbnailChange && thumbnailUrl) {
        onThumbnailChange(thumbnailUrl);
      }
      toast.success('Imagen subida exitosamente');
    } catch (error) {
      console.error('Error uploading image:', error);
      toast.error(error.response?.data?.detail || 'Error al subir imagen');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    onChange('');
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-slate-700">{label}</label>
      
      {preview ? (
        <div className="relative w-32 h-32 rounded-lg overflow-hidden border border-slate-200">
          <img
            src={preview}
            alt="Preview"
            className="w-full h-full object-cover"
          />
          <button
            type="button"
            onClick={handleRemove}
            className="absolute top-1 right-1 p-1 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center w-32 h-32 border-2 border-dashed border-slate-300 rounded-lg cursor-pointer hover:border-teal-500 transition-colors">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            className="hidden"
          />
          {uploading ? (
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-700"></div>
          ) : (
            <>
              <Upload className="w-8 h-8 text-slate-400 mb-2" />
              <span className="text-xs text-slate-500 text-center px-2">Click para subir</span>
            </>
          )}
        </label>
      )}
      <p className="text-xs text-slate-500">
        {type === 'logo' ? 'Max 5MB. Será cuadrada 400x400px' : type === 'category' ? 'Max 5MB. 350x350px' : 'Max 10MB. Será cuadrada 800x800px'}
      </p>
    </div>
  );
};

export default ImageUpload;